// Card — the elevated panel surface (`.orb-card` = bg-elevated + border +
// rounded + shadow). Polymorphic via `as` so it can render the semantically
// correct element (e.g. `as="ul"` for a divided list) without losing the
// surface styling.
import { ComponentPropsWithoutRef, ElementType, ReactNode } from 'react';
import { cn } from './cn';

type CardProps<T extends ElementType> = {
  readonly as?: T;
  readonly className?: string;
  readonly children?: ReactNode;
} & Omit<ComponentPropsWithoutRef<T>, 'as' | 'className' | 'children'>;

export function Card<T extends ElementType = 'div'>({
  as,
  className,
  children,
  ...rest
}: CardProps<T>) {
  const Comp = as ?? 'div';
  return (
    <Comp className={cn('orb-card', className)} {...rest}>
      {children}
    </Comp>
  );
}
